const axios = require("axios");
const { whiteLabelRoutes } = require("../../constants/Routes");

export const generatePdfLink = async (certificateNo) => {
	try {
		let response = await axios.post(whiteLabelRoutes.generatePdfLinkVerified, {
			certificateNo: certificateNo,
			id: "08d72592-bb89-faae-e68f-7b271441b8fa", // Dummy id placed
		});
		let responseJson = response.data;
		return responseJson;
	} catch (error) {
		console.log(error);
	}
};
